// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-main-menu-item .menu-item-more-btn.mat-mdc-icon-button.mat-mdc-button-base {
  height: 24px;
  width: 24px;
  line-height: 24px;
  margin-top: 10px;
}
.fi-main-menu-item .menu-item-more-btn.mat-mdc-icon-button.mat-mdc-button-base .mat-icon {
  font-size: 14px;
  line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./Source/app/components/main-menu/menu-item/menu-item.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAAR;AACQ;EACI,eAAA;EACA,iBAAA;AACZ","sourcesContent":[".fi-main-menu-item {\r\n    .menu-item-more-btn.mat-mdc-icon-button.mat-mdc-button-base {\r\n        height: 24px;\r\n        width: 24px;\r\n        line-height: 24px;\r\n        margin-top: 10px;\r\n        .mat-icon {\r\n            font-size: 14px;\r\n            line-height: 24px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
